// add experiment names here
// example:
// export const POSTXYZ = 'post-xyz'

export const TACQ0005 = 'tacq-0005';
export const TACQ0006 = 'tacq-0006';
export const TACQ0004 = 'tacq-0004';
export const ADPT0003 = 'adpt-0003';